import { Button } from "@mui/material";
import { ModalBuilder, Modal, Form } from "@redriver/cinnamon-mui";
import { useSettings, useSettingsUpdate } from "components/settings";

const Settings = ({ as: As = Button, ...props }) => {
  const settings = useSettings();
  const update = useSettingsUpdate();
  return (
    <ModalBuilder
      withForm
      initialData={{ ...settings }}
      onSubmit={(data) => update(data)}
      renderTrigger={(showModal) => <As {...props} onClick={showModal} />}
      renderModal={(modalProps, formProps) => (
        <Modal.Edit
          {...modalProps}
          size="xs"
          header="Settings"
          submitLabel="Save"
        >
          <Form {...formProps}>
            <Form.Switch
              field="apiBeforeExamples"
              label="Show Props/Function APIs before examples"
            />
            <Form.Switch field="darkMode" label="Dark Mode" />
          </Form>
        </Modal.Edit>
      )}
    />
  );
};

export default Settings;
